export const SYNTAX_LANGUAGES = [
  "astro",
  "bash",
  "c",
  "cmake",
  "cpp",
  "csharp",
  "css",
  "dockerfile",
  "go",
  "graphql",
  "html",
  "ini",
  "java",
  "javascript",
  "json",
  "jsonc",
  "kotlin",
  "makefile",
  "markdown",
  "mdx",
  "php",
  "python",
  "ruby",
  "rust",
  "scss",
  "sql",
  "svelte",
  "swift",
  "terraform",
  "toml",
  "tsx",
  "typescript",
  "vue",
  "xml",
  "yaml",
] as const;

export type SyntaxLanguage = (typeof SYNTAX_LANGUAGES)[number];

const SPECIAL_FILENAMES: Readonly<Record<string, SyntaxLanguage>> = {
  "cmakelists.txt": "cmake",
  dockerfile: "dockerfile",
  gemfile: "ruby",
  makefile: "makefile",
  rakefile: "ruby",
};

const EXTENSIONS: Readonly<Record<string, SyntaxLanguage>> = {
  astro: "astro",
  bash: "bash",
  c: "c",
  cc: "cpp",
  cjs: "javascript",
  cmake: "cmake",
  cpp: "cpp",
  cs: "csharp",
  css: "css",
  cxx: "cpp",
  go: "go",
  gql: "graphql",
  graphql: "graphql",
  h: "c",
  hpp: "cpp",
  htm: "html",
  html: "html",
  ini: "ini",
  java: "java",
  js: "javascript",
  json: "json",
  jsonc: "jsonc",
  jsx: "javascript",
  kt: "kotlin",
  kts: "kotlin",
  md: "markdown",
  mdx: "mdx",
  mjs: "javascript",
  php: "php",
  properties: "ini",
  py: "python",
  rb: "ruby",
  rs: "rust",
  scss: "scss",
  sh: "bash",
  sql: "sql",
  svelte: "svelte",
  svg: "xml",
  swift: "swift",
  tf: "terraform",
  tfvars: "terraform",
  toml: "toml",
  ts: "typescript",
  tsx: "tsx",
  vue: "vue",
  xhtml: "html",
  xml: "xml",
  yaml: "yaml",
  yml: "yaml",
  zsh: "bash",
};

export const languageForPath = (path: string): SyntaxLanguage | null => {
  const filename = path.split("/").at(-1)?.toLowerCase() ?? "";
  const special = SPECIAL_FILENAMES[filename];
  if (special) {
    return special;
  }
  const extension = filename.includes(".") ? filename.split(".").at(-1) : null;
  return extension ? (EXTENSIONS[extension] ?? null) : null;
};
